import { initialConfig, NgxMaskConfig, NgxMaskOptions } from 'ngx-mask';

export const COMMON_MASK_CONFIG = {
  validation: false,
  leadZeroDateTime: true,
};

export const VISTA_CUSTOM_PATTERNS: NgxMaskConfig['patterns'] = {
  C: { pattern: new RegExp('.?') }, // Optional any character
  X: { pattern: new RegExp('[^a-z]') }, // Uppercase letters + symbols
};

export const MASK_CONSTANTS = {
  upperCaseMask: 'UCASE',
};

export const MASK_CONFIG: NgxMaskOptions = {
  ...COMMON_MASK_CONFIG,
  patterns: { ...initialConfig.patterns, ...VISTA_CUSTOM_PATTERNS },
};
